export default __webpack_public_path__ + "media/images/admin/premium_cta_description_example-f221a225a3488defc73952f8feee4b18.png";